import * as actionTypes from '../../constants/actionTypes';

const initialState = {};

export default function(state = initialState, action) {
  switch (action.type) {
    case actionTypes.ACTIVE_CROPS_SUCCESS:
      return action.payload;
    case actionTypes.SHOW_LOADER:
      switch (action.payload) {
        case actionTypes.ACTIVE_CROPS:
          return Object.assign({}, state, { isActiveCropsLoading: true });
        default:
          return Object.assign({}, state);
      }
    case actionTypes.HIDE_LOADER:
      switch (action.payload) {
        case actionTypes.ACTIVE_CROPS:
          return Object.assign({}, state, { isActiveCropsLoading: false });
        default:
          return Object.assign({}, state);
      }
    default:
      return state;
  }
}
